import { useMutation } from '@tanstack/react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
import { CustomerAddress, Nullable, Order } from '@framework/types';
import { CartItem } from '@utils/generate-cart-item';

export type CreateOrderRequest = {
  address: CustomerAddress;
  notes: Nullable<string>;
  items: CartItem[];
};

async function checkout(request: CreateOrderRequest) {
  const { data } = await http.post(API_ENDPOINTS.ORDERS, {
    items: request.items,
    comment: request.notes,
    street: request.address.street_address,
    city: request.address.city,
    zipcode: request.address.zip,
    country: request.address.country,
  });
  return data.data as Order;
}
export const useCheckoutMutation = () => {
  return useMutation({
    mutationFn: (payload: CreateOrderRequest) => checkout(payload),
    onError: (data) => {
      console.error(data, 'Checkout error response');
    },
  });
};
